import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-view-drawer',
  templateUrl: './table-view-drawer.component.html',
  styleUrl: './table-view-drawer.component.scss',
})
export class TableViewDrawerComponent {
  @Input() isOpen: boolean = false;
  @Input() pageType: string = '';
  @Input() states: any[] = [];
  @Input() trackerFilters: any;
  @Input() masterLeafletData: any[] = [];
  @Input() tenantConfig: any;
  @Input() trackerTabs: any;
  @Input() pager: any;
  @Input() _service: any;

  @Output() close = new EventEmitter<void>();
  @Output() selectedState = new EventEmitter<any>();
  @Output() tableAction = new EventEmitter<any>();
  @Output() pageSizeChange = new EventEmitter<any>();
  @Output() paginationAction = new EventEmitter<any>();

  closeDrawer(): void {
    this.isOpen = false;
    this.close.emit();
  }

  handleStateSelection(event: any): void {
    this.selectedState.emit(event);
  }

  onTableAction(event: any): void {
    this.tableAction.emit(event);
  }

  onPageSizeChange(event: any): void {
    this.pageSizeChange.emit(event);
  }

  onPaginateChange(event: any): void {
    this.paginationAction.emit(event);
  }
}
